<template>
    <div class="search-container" :class="{ searchActive: showSearch }">
      <input type="text" v-model="searchTerm" placeholder="Search..." @keyup="search">
    </div>
  </template>
  
  <script>
  export default {
    name: 'SearchComponent',
    props: {
      showSearch: {
        type: Boolean,
        required: true,
      },
      items: {
        type: Array,
        required: true,
        },
    },
    data() {
      return {
        searchTerm: '',
        searchResults: [],
      };
    },
    methods: {
      search() {
        const searchTerm = this.searchTerm.toLowerCase().trim();
        if (!searchTerm) {
          this.searchResults = []; // Reset search results
        } else {
          const searchWords = searchTerm.split(/\s+/); // Split into individual words
          
          this.searchResults = this.items.filter(item => {
            return searchWords.every(word => {
              // Convert all relevant fields to lowercase once (for efficiency)
              const sku = item.SKU?.toLowerCase() || '';
              const price = item.Price?.toString() || '';
              const manufacturer = item.ManufacturerName?.toLowerCase() || '';
              const model = item.Model?.toLowerCase().replace(/[^a-z0-9]/g, '') || '';  // Remove special chars
              const watchLocation = item.WatchLocation?.toLowerCase() || '';
              const name = item.Name?.toLowerCase() || '';
              const jewelleryType = item.jewelleryType?.toLowerCase() || '';
              const jewelleryMetal = item.jewelleryMetal?.toLowerCase() || '';
              const jewelleryStone = item.jewelleryStone?.toLowerCase() || '';
              const location = item.Location?.toLowerCase() || '';
              const material = item.Material?.toLowerCase() || '';
              // Check if the word exists in any field
              return (
                sku.includes(word) ||
                price.includes(word) ||
                manufacturer.includes(word) ||
                model.includes(word) ||
                watchLocation.includes(word) ||
                name.includes(word) ||
                jewelleryType.includes(word) ||
                jewelleryMetal.includes(word) ||
                jewelleryStone.includes(word) ||
                location.includes(word) ||
                material.includes(word)
              );
            });
          });
        }
        this.$emit('search-results', this.searchResults);
      }
    }
  };
  </script>
  